var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOphosWorkRightBg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 482,
    viewBox: "0 0 425 482",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1C1D",
    fillRule: "evenodd",
    stroke: "#000",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.25 308 423.75 308.009 457 364 423.75 420 357.25 420 324 364"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.25 189 425.75 189.009 459 245 425.75 301 359.25 301 326 245"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.25 244 313.75 244.009 347 300 313.75 356 247.25 356 214 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.25 368 313.75 368.009 347 424 313.75 480 247.25 480 214 424"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.25 180 206.75 180.009 240 236 206.75 292 140.25 292 107 236"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.25 117 99.75 117.009 133 173 99.75 229 33.25 229 0 173"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.25 239 99.75 239.009 133 295 99.75 351 33.25 351 0 295"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.25 60 211.75 60.009 245 116 211.75 172 145.25 172 112 116"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.25 0 320.75 .009 354 56 320.75 112 254.25 112 221 56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.25 124 318.75 124.009 352 180 318.75 236 252.25 236 219 180"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOphosWorkRightBg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ophos-work-right-bg.f1745b13.svg";
export { ForwardRef as ReactComponent };